import './PaperlessBanner.scss';

import React, { Fragment } from 'react';

import { ReactComponent as Dollar } from 'assets/icons/dollar.svg';
import { feesAndMinimumsUrl } from 'services/Externals';

const AllPaperlessBanner = ({ hasInvalidOrMissingEmail }) => (
  <Fragment>
    <div className="all-paperless-banner">
      <Dollar />
      <p>Account service fee waived based on email delivery selections.</p>
    </div>
    <p className="learn-more">
      <a
        className={hasInvalidOrMissingEmail ? 'disabled' : ''}
        href={feesAndMinimumsUrl}
        id="paperless-learn-more-link"
        rel="noopener noreferrer"
        target="_blank">
        Learn more
      </a>{' '}
      about the account service fee and other ways you can get it waived.
    </p>
  </Fragment>
);

export default AllPaperlessBanner;
